<template>
  <p>
    <small>© {{ year }} GVL</small>
  </p>
</template>

<script>
export default {
  name: 'Footer_Copyright',
  props: {},
  data: function () {
    return {
      year: (new Date()).getFullYear()
    }
  }
}
</script>
